import useToggle from 'ui-components/hooks/use-toggle';

const useModal = (initialOpenState = false) => {
  const { activate: open, isActivated: isOpen, deactivate: close } = useToggle(initialOpenState);

  return { close, isOpen, open };
};

export default useModal;
